// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see AwardCampaignAwardSendSuccessEvent
 */
export var AwardCampaignAwardSendSuccess = function (_a) {
    var journeyStepKey = _a.journeyStepKey, campaignToken = _a.campaignToken;
    return ({
        name: "AwardCampaign AwardSend Success",
        parameters: {
            cdf_entity: "AwardCampaign",
            cdf_action: "AwardSend",
            journey_step_key: journeyStepKey !== undefined && journeyStepKey !== null ? journeyStepKey.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            campaign_token: campaignToken !== undefined && campaignToken !== null ? campaignToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
